import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { showLoading, hideLoading } from '@/utils/tool'
import { message } from 'antd'
import { handleJumpByPath, interceptors } from './config'

let isShowMessage = false
let timer: any

// 从环境变量获取API基础URL
const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL || '/api-aa2-agent12'

// Global logout callback for 401 handling
let globalLogoutCallback: (() => void) | null = null

export function setGlobalLogoutCallback(callback: (() => void) | null) {
  globalLogoutCallback = callback
}

// Token management utilities
export function setToken(token: string): void {
  localStorage.setItem('auth_token', token)
}

export function getToken(): string | null {
  return localStorage.getItem('auth_token')
}

export function removeToken(): void {
  localStorage.removeItem('auth_token')
}

// User information management utilities
export interface User {
  id: number
  username: string
  email: string
  // Add other user properties as needed
}

export function setUser(user: User): void {
  localStorage.setItem('user', JSON.stringify(user))
}

export function getUser(): User | null {
  const userJson = localStorage.getItem('user')
  return userJson ? JSON.parse(userJson) : null
}

export function removeUser(): void {
  localStorage.removeItem('user')
}

// Clear all auth data
export function clearAuth(): void {
  removeToken()
  removeUser()
}

// Wrapped fetch function with automatic token handling
export async function fetchWithAuth(
  url: string,
  options: RequestInit = {},
  otherInfo: any = {}
) {
  otherInfo = {
    isNeedRefreshToken: true, //是否需要请求接口后调一下刷新token的接口
    isNeedToken: true,
    responseType: 'json',
    isFormatData: false,
    isTest: false,
    isNeedLoading: true,
    timeout: 30000,
    ...otherInfo,
  }
  const token = getToken()

  // Create headers object if not provided
  const headers = new Headers(options.headers || {})

  // Add token to headers if available
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  // Add Content-Type: application/json for POST/PUT/PATCH requests if not specified
  const method = options.method?.toUpperCase() || 'GET'
  if (
    (method === 'POST' || method === 'PUT' || method === 'PATCH') &&
    !headers.has('Content-Type')
  ) {
    if (otherInfo.isFormatData) {
    } else {
      headers.set('Content-Type', 'application/json')
    }
  }

  if (otherInfo.isNeedLoading) {
    showLoading()
  }

  // Create AbortController for 30-second timeout
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), otherInfo.timeout)

  const requestOptions: any = {
    ...options,
    headers,
    signal: controller.signal,
  }

  try {
    const response = await fetch(`${baseUrl}${url}`, requestOptions)
    clearTimeout(timeoutId)
    hideLoading()

    if (response.status === 401) {
      if (isShowMessage === false) {
        isShowMessage = true
        message.warning('请重新登录')
        console.log('请重新登录')
        clearAuth()
        // Call global logout callback to update React state immediately
        if (globalLogoutCallback) {
          globalLogoutCallback()
        }
        clearTimeout(timer)
        // window.location.reload()
        timer = setTimeout(() => {
          isShowMessage = false
        }, 2000)
      }
    } else if (!response.ok) {
      //throw new Error(`API request failed: ${response.status} ${response.statusN}`)
    }

    if (otherInfo && otherInfo.responseType !== 'json') {
      if (otherInfo.responseType === 'blob') {
        return response.blob()
      } else if (otherInfo.responseType === 'text') {
        return response.text()
      } else {
        let res = await response.json()
        interceptors(res)
        return res
      }
    } else {
      let res = await response.json()
      interceptors(res)

      return res
    }
    return response
  } catch (error: any) {
    clearTimeout(timeoutId)
    hideLoading()
    if (error.name === 'AbortError') {
      throw new Error('请求超时（30秒）')
    }
    throw error
  }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
